import React, { useState, useEffect } from 'react';

const ExternalVoucherLog = () => {
  const [storeName, setStoreName] = useState('');
  const [voucherCode, setVoucherCode] = useState('');
  const [amount, setAmount] = useState('');
  const [issuedDate, setIssuedDate] = useState('');
  const [message, setMessage] = useState('');
  const [externalVouchers, setExternalVouchers] = useState([]);

  // Explicitly load existing external vouchers
  const loadExternalVouchers = () => {
    fetch('https://loyaltyprogram.navalsupermart.com/api/get_external_vouchers.php')
      .then(res => res.json())
      .then(data => {
        if (data.success) setExternalVouchers(data.vouchers);
      })
      .catch(err => console.error('Failed to fetch external vouchers:', err));
  };

  useEffect(() => {
    loadExternalVouchers();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      store_name: storeName,
      voucher_code: voucherCode,
      amount,
      issued_date: issuedDate
    };

    fetch('https://loyaltyprogram.navalsupermart.com/api/add_external_voucher.php', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(formData)
    })
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        setMessage('✅ External Voucher Added!');
        setStoreName('');
        setVoucherCode('');
        setAmount('');
        setIssuedDate('');
        loadExternalVouchers(); // Explicitly reload vouchers after adding
      } else {
        setMessage(`❌ ${data.message}`);
      }
    })
    .catch(err => setMessage('❌ Error submitting form.'));
  };

  return (
    <div>
      <h2>Add External Voucher</h2>
      <form onSubmit={handleSubmit}>
        <label>Store Name:</label>
        <input type="text" value={storeName} onChange={e => setStoreName(e.target.value)} required/>

        <label>Voucher Code:</label>
        <input type="text" value={voucherCode} onChange={e => setVoucherCode(e.target.value)} required/>

        <label>Amount (₱):</label>
        <input type="number" step="0.01" value={amount} onChange={e => setAmount(e.target.value)} required/>

        <label>Issued Date:</label>
        <input type="date" value={issuedDate} onChange={e => setIssuedDate(e.target.value)} required/>

        <button type="submit">Add External Voucher</button>
      </form>

      {message && <p>{message}</p>}

      <hr/>

      <h2>Existing External Vouchers</h2>
      <table border="1" cellPadding="8">
        <thead>
          <tr>
            <th>Store Name</th>
            <th>Voucher Code</th>
            <th>Amount</th>
            <th>Issued Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {externalVouchers.map(ev => (
            <tr key={ev.id}>
              <td>{ev.store_name}</td>
              <td>{ev.voucher_code}</td>
              <td>₱{ev.amount}</td>
              <td>{ev.issued_date}</td>
              <td>{ev.used ? 'Used' : 'Available'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ExternalVoucherLog;